import { render, staticRenderFns } from "./EditCard.vue?vue&type=template&id=cb0bab7c&scoped=true"
import script from "./EditCard.vue?vue&type=script&lang=js"
export * from "./EditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0bab7c",
  null
  
)

export default component.exports